
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lecture/[id]",
      function () {
        return require("private-next-pages/lecture/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lecture/[id]"])
      });
    }
  